import _cookies from "../../../shared/utils/_cookies";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentContacts = async (params) => {
  const res = await axios.middleware(
    "/Social.asmx/PainelGruposContatosFavoritos",
    {
      params,
    }
  );

  return res[0].data.map((foo) => ({ ...foo, currentPage: params.pagNum }));
};

export const useInfiniteStudentContacts = ({
  config,
  studentId = 1,
  pageLength = 30,
  pageNumber = 1,
  filter = "",
  groupsFilter = "",
  closeFriendsFilter = false,
} = {}) => {
  const params = {
    alunoid: studentId,
    pagNum: pageNumber,
    pagLength: pageLength,
    filtro_nome: filter,
    filtro_grupo: groupsFilter,
    favoritos: closeFriendsFilter ? "S" : "N",
  };
  return useInfiniteQuery({
    ...config,
    queryKey: [
      "socialMediaUserContacts",
      { studentId, filter, groupsFilter, closeFriendsFilter },
    ],
    queryFn: ({ pageParam = 1 }) =>
      getStudentContacts({ ...params, pagNum: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.[0]?.currentPage == lastPage?.[0]?.total_paginas) {
        return undefined;
      }
      return lastPage?.[0]?.currentPage + 1;
    },
  });
};
